<template>
  <div class="leco-content">
    <div class="page-title">
      <div class="float-left">トレーニング予定変更</div>
      <div class="float-right">
        <button
          style="width: 90px"
          @click="openSharingModal"
          class="btn btn-outline-secondary registry-btn btn-sm share-btn"
          type="button"
        >
          共有
        </button>
      </div>
    </div>

    <!-- 初期読み込み時のローディングアイコン -->
    <loading :active.sync="isPostLoading" class="post-loading" />

    <!-- 更新前の確認メッセージモーダル -->
    <ConfirmationModal
      :confirmation_title="updConfirm.title"
      :confirmation_top_msg="updConfirm.top_msg"
      :confirmation_warn_list="updConfirm.warn_list"
      v-if="isShowUpdConfirmationModal"
      v-on:confirm-cancel="cancelUpdConfirmationModal"
      v-on:confirm-ok="okUpdConfirmationModal"
    />

    <!-- 削除前の確認メッセージモーダル -->
    <ConfirmationModal
      :confirmation_title="delConfirm.title"
      :confirmation_top_msg="delConfirm.top_msg"
      :confirmation_warn_list="delConfirm.warn_list"
      v-if="isShowDelConfirmationModal"
      v-on:confirm-cancel="cancelDelConfirmationModal"
      v-on:confirm-ok="okDelConfirmationModal"
    />

    <!-- トレーニング予定の共有内容コピー用モーダル -->
    <TrainingPlanSharingModal
      :training_plan_id="plan_id"
      v-if="isShowSharingModal"
      v-on:announce-ok="okAnnounceModal"
    />

    <!-- 入力バリデーション等のエラーメッセージ領域 -->
    <div v-if="error != ''" class="alert alert-danger">{{ error }}</div>
    <div v-show="mainLoading" class="loader">loading...</div>

    <transition>
      <div v-show="!mainLoading" class="container-fluid">
        <div class="form-group row">
          <label class="col-sm-2">トレーニング名</label>
          <div class="col-sm-10">
            <input class="form-control" v-model="training_planning_name" />
          </div>
        </div>

        <div class="form-group row">
          <label class="col-sm-2">分類</label>
          <div class="col-sm-10">
            <div class="float-left mb-3">
              <span>大分類</span>
              <span class="tag-disp">{{ training_category_name }}</span>
            </div>
            <div class="float-left mb-3">
              <span>中分類</span>
              <span class="tag-disp">{{ training_sub_category_name }}</span>
            </div>
            <div class="float-left mb-3">
              <span>マスタ</span>
              <span class="tag-disp">{{ training_name }}</span>
            </div>
          </div>
        </div>

        <b-form @submit.prevent="put_training_planning">
          <dl v-for="coach in coaches" :key="coach.index">
            <div class="form-group row coach_selection">
              <div class="col-sm-2">講師{{ coach.index + 1 }}</div>
              <div class="col-sm-10">
                <div class="coach_wraper">
                  <div>
                    <label>
                      <b-form-group label="講師分類" class="coach_selection">
                        <b-form-radio-group
                          style="width: 300px"
                          v-model="coach.internal_coach_flag"
                          :options="internal_coach_options"
                          :name="'internal_coach_type_' + coach.index"
                          button-variant="outline-primary"
                          class="select-group"
                          :required="true"
                          v-on:change="onChangeCoach()"
                        ></b-form-radio-group>
                      </b-form-group>
                    </label>

                    <label>
                      <b-form-group label="講師タイプ" class="coach_selection">
                        <b-form-radio-group
                          style="width: 300px"
                          v-model="coach.coach_type"
                          :options="coach_type_options"
                          :name="'coach_type_' + coach.index"
                          button-variant="outline-primary"
                          class="select-group coach_selection"
                          :required="true"
                        ></b-form-radio-group>
                      </b-form-group>
                    </label>
                    <label class="float-right">
                      <button
                        style="width: 90px"
                        @click="onDeleteCoach(coach.index)"
                        class="btn btn-outline-danger float-right coach-delete-btn"
                        type="button"
                      >
                        削除
                      </button>
                    </label>
                  </div>
                  <div v-if="coach.internal_coach_flag == 1">
                    <v-select
                      :options="users"
                      label="name"
                      v-model="coach.coach_user_id"
                      :reduce="(users) => users.id"
                    >
                    </v-select>
                  </div>
                  <div v-if="coach.internal_coach_flag == 0">
                    <input
                      class="form-control"
                      v-model="coach.coach_name"
                      id=""
                      placeholder="外部講師名を記入してください"
                      maxlength="30"
                      style="height: 34px"
                    />
                  </div>
                </div>
              </div>
            </div>
          </dl>

          <div class="form-group row">
            <label class="col-sm-2">開催日</label>
            <div class="col-sm-10">
              <input
                type="date"
                class="form-control"
                data-toggle="datepicker"
                v-model="date"
                style="float: left; width: fit-content"
              />
              <button
                style="float: right"
                @click="onAddCoach"
                class="btn btn-outline-danger coach-add-btn"
                type="button"
              >
                講師追加
              </button>
            </div>
          </div>

          <div class="form-group row">
            <label class="col-sm-2">実施時間</label>
            <span class="form-inline col-sm-10">
              <div class="form-group">
                <b-form-select
                  v-model="start_hour"
                  class="form-control time-select"
                >
                  <option value="01">1</option>
                  <option value="02">2</option>
                  <option value="03">3</option>
                  <option value="04">4</option>
                  <option value="05">5</option>
                  <option value="06">6</option>
                  <option value="07">7</option>
                  <option value="08">8</option>
                  <option value="09">9</option>
                  <option value="10">10</option>
                  <option value="11">11</option>
                  <option value="12">12</option>
                  <option value="13">13</option>
                  <option value="14">14</option>
                  <option value="15">15</option>
                  <option value="16">16</option>
                  <option value="17">17</option>
                  <option value="18">18</option>
                  <option value="19">19</option>
                  <option value="20">20</option>
                  <option value="21">21</option>
                  <option value="22">22</option>
                  <option value="23">23</option>
                  <option value="24">24</option>
                </b-form-select>
                <label>：</label>
                <b-form-select
                  v-model="start_minute"
                  class="form-control time-select"
                >
                  <option value="00">00</option>
                  <option value="15">15</option>
                  <option value="30">30</option>
                  <option value="45">45</option>
                </b-form-select>
                <label class="margin-side">～</label>
                <b-form-select
                  v-model="end_hour"
                  class="form-control time-select"
                >
                  <option value="01">1</option>
                  <option value="02">2</option>
                  <option value="03">3</option>
                  <option value="04">4</option>
                  <option value="05">5</option>
                  <option value="06">6</option>
                  <option value="07">7</option>
                  <option value="08">8</option>
                  <option value="09">9</option>
                  <option value="10">10</option>
                  <option value="11">11</option>
                  <option value="12">12</option>
                  <option value="13">13</option>
                  <option value="14">14</option>
                  <option value="15">15</option>
                  <option value="16">16</option>
                  <option value="17">17</option>
                  <option value="18">18</option>
                  <option value="19">19</option>
                  <option value="20">20</option>
                  <option value="21">21</option>
                  <option value="22">22</option>
                  <option value="23">23</option>
                  <option value="24">24</option>
                </b-form-select>
                <label>：</label>
                <b-form-select
                  v-model="end_minute"
                  class="form-control time-select"
                >
                  <option value="00">00</option>
                  <option value="15">15</option>
                  <option value="30">30</option>
                  <option value="45">45</option>
                </b-form-select>
              </div>
            </span>
          </div>

          <div class="form-group row">
            <label class="col-sm-2">TeamsURL</label>
            <span class="col-sm-10">
              <b-form-radio-group
                v-model="is_url_create_enabled"
                :options="is_url_create_enabled_options"
                :name="'is_url_create_enabled'"
                button-variant="outline-primary"
                class="select-group"
                :required="true"
                :disabled="is_urlCreateEnabledActive"
                v-on:change="onChangeIsTeamsUrlCreate"
                v-tooltip.top="
                  'Teamsの発行設定は変更できません。変更する場合はトレーニング予定を削除して再登録してください。'
                "
              ></b-form-radio-group>
              <div
                v-if="meeting_id == '' || meeting_id == null"
                class="text-info"
              >
                LECOからTeams参加URLが発行されていません。講師から個別に参加URLを案内してください。
              </div>
              <span v-else>
                <a :href="join_url" target="_blank">{{ join_url }}</a>
              </span>
            </span>
          </div>

          <div class="form-group row">
            <label class="col-sm-2">Teamsテナント</label>
            <div class="col-sm-10">
              <b-form-group class="coach_selection">
                <b-form-radio-group
                  v-model="web_meeting_connection_selected"
                  :options="web_meeting_connection_settings"
                  :name="'web_meeting_connection_selected'"
                  button-variant="outline-primary"
                  class="select-group"
                  :required="true"
                  :disabled="web_meeting_connection_select_disabled"
                  v-tooltip.top="
                    'Teamsテナント設定は変更できません。変更する場合はトレーニング予定を削除して再登録してください。'
                  "
                ></b-form-radio-group>
              </b-form-group>
            </div>
          </div>

          <div class="form-group row">
            <label class="col-sm-2">主催者</label>
            <div class="col-sm-10">
              <v-select
                :options="users"
                label="name"
                v-model="teams_host_user_id"
                :reduce="(users) => users.id"
                :clearable="false"
                placeholder="選択してください"
                :disabled="!is_url_create_enabled"
                :class="{ 'text-muted': !is_url_create_enabled }" 
              ></v-select>
              <small class="form-text text-muted mt-2">
                ※Microsoft予定やTeamsのミーティングオーナーを指定します。Teamsでは主催者のみがブレイクアウトルームの操作が可能です。
              </small>
            </div>
          </div>

          <div class="form-group row">
            <label class="col-sm-2">録画</label>
            <span class="col-sm-10">
              <b-form-radio-group
                v-model="is_recording_enabled"
                :options="is_recording_enabled_options"
                :name="'is_recording_enabled'"
                button-variant="outline-primary"
                class="select-group"
                :required="true"
                :disabled="!is_url_create_enabled || checkPastDateTraining()"
              ></b-form-radio-group>
              <div
                class="vertical-middle-wrapper"
                v-if="!is_share_url_editable"
              >
                <div
                  v-if="share_url == '' || share_url == null"
                  class="text-info float-left"
                >
                  録画データは保存されていません。
                </div>
                <router-link
                  v-else
                  :to="{
                    name: 'web-meeting-rec-watch-redirect',
                    params: { id: plan_id }
                  }"
                  style="word-break: break-all"
                >
                  {{ share_url }}
                </router-link>
                <button
                  style="width: 60px"
                  @click="is_share_url_editable = true"
                  class="btn btn-outline-secondary registry-btn btn-sm share-btn float-left"
                  type="button"
                >
                  変更
                </button>
              </div>
              <div v-else>
                <input
                  class="form-control"
                  style="margin-top: 7px"
                  v-model="share_url"
                  placeholder="任意のトレーニング録画のURLを保存できます"
                />
              </div>
            </span>
          </div>

          <div class="form-group row">
            <label class="col-sm-2">会場</label>
            <span class="col-sm-10">
              <input class="form-control" v-model="place" maxlength="30" />
            </span>
          </div>

          <div class="form-group row">
            <label class="col-sm-2">資料格納先URL</label>
            <span class="col-sm-10">
              <input
                class="form-control"
                v-model="trainingMaterialUrl"
                placeholder="トレーニング資料の格納パスが決まっている場合記載。共有リンク作成時に期限を【無期限】にしてください"
              />
            </span>
          </div>

          <div class="form-group row">
            <label class="col-sm-2">対象者</label>
            <span class="col-sm-10">
              <textarea
                class="form-control"
                v-model="target_person"
                rows="2"
                placeholder="（未登録）"
                :disabled="true"
              />
            </span>
          </div>

          <div class="form-group row">
            <label class="col-sm-2">案内文</label>
            <span class="col-sm-10">
              <textarea
                class="form-control"
                v-model="informationMsg"
                rows="6"
                placeholder="（未登録）"
                :disabled="true"
              />
            </span>
          </div>

          <button
            style="float: right"
            class="btn btn-outline-secondary registry-btn"
          >
            更新
          </button>
          <button
            style="float: right"
            type="button"
            @click="delete_training_planning"
            class="btn btn-outline-danger training-delete-btn"
          >
            削除
          </button>
        </b-form>
      </div>
    </transition>
  </div>
</template>

<script>
import Vue from "vue";
import { mapGetters } from "vuex";
import { API_BASE_URL } from "@/common/config";
import axios from "axios";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import ConfirmationModal from "@/components/LECO_ConfirmationModal.vue";
import TrainingPlanSharingModal from "@/components/LECO_TrainingPlanSharingModal.vue";

// v-tooltip Setup
import VTooltip from "v-tooltip";
Vue.use(VTooltip);

// vue-select
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";

// 使用不可文字（OneDrive/Windowsで問題になりやすい文字をタイトルの禁止文字列に指定）
export const FORBIDDEN_TITLE_CHARS = Object.freeze([
  '<', '>', '"', ':', '/', '\\', '|', '?', '*', '#', '%'
]);

// 文字クラス用にエスケープ(正規表現で特殊な意味を持つ文字を無効化)
const _escapeForCharClass = (s) => s.replace(/[-\\^$*+?.()|[\]{}]/g, '\\$&');

const FORBIDDEN_TITLE_REGEX = new RegExp(
  `[${FORBIDDEN_TITLE_CHARS.map(_escapeForCharClass).join('')}]`,
  'g'
);

export default {
  name: "planning",
  data() {
    return {
      training_master_id: 0,
      training_name: "",
      training_planning_name: "",
      training_category_id: 0,
      training_category_name: "",
      training_sub_category_id: 0,
      training_sub_category_name: "",
      training_id: 0,
      plan_id: 0,
      date: "",
      start_hour: "09",
      start_minute: "00",
      end_hour: "12",
      end_minute: "00",
      coaches: [],
      place: "",
      trainingMaterialUrl: "",
      target_person: "",
      informationMsg: "",
      input_details: {},
      users: [
        {
          id: 0,
          name: ""
        }
      ],
      error: "",
      isUserSelected: false,
      isCoachNameInputed: "",
      isDateInputed: "",
      isPostLoading: false,
      mainLoading: false,
      isUserGetted: false,
      isTrainingInfoGetted: false,
      logger: this.$store.state.logger,
      web_meeting_connection_settings: [],
      web_meeting_connection_selected: 0,
      web_meeting_connection_select_disabled: true,
      is_urlCreateEnabledActive: true,
      is_recordingEnabledActive: false,
      internal_coach_options: [
        { text: "社員", value: 1 },
        { text: "外部講師", value: 0 }
      ],
      coach_type_options: [
        { text: "メイン講師", value: 0 },
        { text: "サブ講師", value: 1 }
      ],
      is_url_create_enabled_options: [
        { text: "発行する", value: true },
        { text: "発行しない", value: false }
      ],
      is_recording_enabled_options: [
        { text: "録画する", value: true },
        { text: "録画しない", value: false }
      ],
      is_url_create_enabled: true,
      is_recording_enabled: true,
      is_external_coach_alert: false,
      meeting_id: "",
      join_url: "",
      share_url: "",
      is_share_url_editable: false,
      isShowUpdConfirmationModal: false,
      isShowDelConfirmationModal: false,
      isShowSharingModal: false,
      teams_host_user_id: "", 
      updConfirm: {
        title: "トレーニング予定を更新しても良いですか？",
        top_msg: "以下を確認し、問題がなければ「OK」をクリックしてください。",
        warn_list: [
          { msg: "資料の格納先URLの有効期限は無期限になっていますか？" },
          {
            msg: "会議招集などスケジューラーへの登録は各自で実施をお願いします。"
          },
          {
            msg: "Slackへの再案内は自動では行われません。必要に応じて各自で案内をお願いします。"
          }
        ]
      },
      delConfirm: {
        title: "トレーニング予定を削除しても良いですか？",
        top_msg: "問題がなければ「OK」をクリックしてください。",
        warn_list: []
      }
    };
  },
  components: {
    loading: Loading,
    vSelect,
    ConfirmationModal,
    TrainingPlanSharingModal
  },
  methods: {
    //更新ボタンクリック時に実行される処理
    put_training_planning: function () {
      this.logger.debug("called:put_training_planning");

      this.error = "";

      // 必須入力チェック（トレーニング名）
      const src = (this.training_planning_name == null ? '' : this.training_planning_name);
      if (!src.trim()) {
        this.error = "トレーニング名を入力してください。";
        return
      }

      // トレーニング名に使用できない文字が含まれていないかチェック
      const hits = src.match(FORBIDDEN_TITLE_REGEX) || [];
      if (hits.length) {
        const unique = [...new Set(hits)];
        this.error = `トレーニング名に使用できない文字が含まれています。全角に置き換えるか別の文字に変更してください: ${unique.join(' ')}`;
        return;
      }

      //講師名が空の講師配列は削除する
      for (var i = 0; i < this.coaches.length; i++) {
        //内部講師の場合
        if (this.coaches[i].internal_coach_flag == 1) {
          if (
            this.coaches[i].coach_user_id == "" ||
            this.coaches[i].coach_user_id == "0"
          ) {
            this.coaches.splice(i, 1);
          }
        } else {
          //外部講師の場合
          if (this.coaches[i].coach_name == "") {
            this.coaches.splice(i, 1);
          }
        }
      }

      //講師情報の不要な変数をクリア
      for (var k = 0; k < this.coaches.length; k++) {
        if (this.coaches[k].internal_coach_flag == 1) {
          // 社内講師の場合、外部講師名をクリア
          this.coaches[k].coach_name = "";
        } else if (this.coaches[k].internal_coach_flag == 0) {
          // 外部講師の場合、講師IDをクリア
          this.coaches[k].coach_user_id = "";
        }
      }

      //講師欄がひとつもない（＝講師ゼロ）場合は、エラーメッセージを表示
      if (this.coaches.length == 0) {
        this.error =
          "講師を一人以上登録してください（「講師追加」ボタンで講師欄を追加してください。）";
        return;
      }

      // 講師欄はあるが1人も指定されていない場合は、エラーメッセージを表示
      var coach_count = 0;
      for (var j = 0; j < this.coaches.length; j++) {
        if (
          (this.coaches[j].internal_coach_flag == 1 &&
            this.coaches[j].coach_user_id != "") ||
          (this.coaches[j].internal_coach_flag == 0 &&
            this.coaches[j].coach_name != "")
        ) {
          coach_count++;
        }
      }
      if (coach_count == 0) {
        this.error = "講師を一人以上登録してください。";
        return;
      }

      // 必須入力チェック（開催日）
      if (this.date == "") {
        this.error = "開催日を選択してください。";
        return;
      }

      // 必須入力チェック（主催者）
      if (this.is_url_create_enabled && !this.teams_host_user_id) {
        this.error = "主催者を選択してください。";
        return;
      }
      // 確認ダイアログを表示
      this.openUpdConfirmationModal();
    },
    delete_training_planning: function () {
      this.logger.debug("called:delete_training_planning");

      // ローディングアイコン表示
      this.isPostLoading = true;

      // 削除前にアンケート回答数のチェック
      this.logger.info(
        "削除前にアンケート回答の有無をチェック。ID=" + this.plan_id
      );
      let api_url =
        API_BASE_URL +
        "training-plannings/" +
        this.plan_id +
        "/questionnaire-answer-summary";
      axios
        .get(api_url, {
          headers: {
            Authorization: this.$store.getters.currentUser.idToken.jwtToken
          }
        })
        .then((result) => {
          this.logger.debug(
            "get questionnaire-answer-summary api result:\n" +
              JSON.stringify(result)
          );
          this.isPostLoading = false;
          if ("statusCode" in result.data) {
            //statusCodeが200なら画面表示
            if (result.data.statusCode == 200) {
              var answerCount =
                result.data.body.answers[0].answerDetails.length;
              this.logger.info(
                "アンケート回答サマリー取得成功（count=" + answerCount + "）。"
              );

              if (answerCount > 0) {
                this.error =
                  "アンケート回答がされているトレーニングは削除できません（アンケート回答：" +
                  answerCount +
                  "名）。";
                return;
              } else {
                // 確認ダイアログを表示
                this.openDelConfirmationModal();
              }
            } else {
              this.logger.error(
                "GET(questionnaire-answer-summary get) API Unexpected status error"
              );
              this.logger.error(JSON.stringify(result));
              this.$router.push("/system-error500");
            }
          } else {
            this.logger.error(
              "GET(questionnaire-answer-summary　get) API Unexpected error"
            );
            this.logger.error(JSON.stringify(result));
            this.$router.push("/system-error500");
          }
        })
        .catch((error) => {
          this.isPostLoading = false;
          this.logger.error("API(questionnaire-answer-summary　get) error");
          this.logger.error(error);
          this.$router.push("/system-error500");
        });
    },

    // TeamsURL発行に合わせて録画可否を自動設定する
    onChangeIsTeamsUrlCreate(value) {
      this.logger.debug("onChangeIsTeamsUrlCreate:" + value);
      if (value) {
        this.is_recordingEnabledActive = false;
      } else {
        this.is_recording_enabled = false;
        this.is_recordingEnabledActive = true;
      }
    },


    onChangeCoach() {
      this.error = "";
      for (var i = 0; i < this.coaches.length -1; i++) {
        //内部講師の場合
        if (this.coaches[i].internal_coach_flag == 1) {
          if (
            this.coaches[i].coach_user_id == "" ||
            this.coaches[i].coach_user_id == "0"
            
          ) {
            //講師名が空の講師配列は削除する
            this.coaches.splice(i, 1);
          }
          // 確認ダイアログ用に社員の講師名をテキストで保存
          for (let j = 0; j < this.users.length; j++) {
            if (this.users[j].id == this.coaches[i].coach_user_id) {
              this.coaches[i].coach_user_name = this.users[j].name;
            }
          }
        } else {
          //外部講師の場合
          if (this.coaches[i].coach_name == "") {
            //講師名が空の講師配列は削除する
            this.coaches.splice(i, 1); 
          }
        }
      }
  },

    //登録する講師を増やすため処理を行う
    onAddCoach(event) {
      this.logger.debug(event);
      this.coaches.push({
        index: this.coaches.length,
        coach_type: 0,
        internal_coach_flag: 1,
        coach_user_id: "",
        coach_name: ""
      });
    },

    //登録する講師を減らすため処理を行う
    onDeleteCoach(index) {
      this.logger.debug(index);
      this.coaches.splice(index, 1);
      //配列のIndexを洗い替えする
      for (let id = 0; id < this.coaches.length; id++) {
        this.coaches[id].index = id;
      }
    },

    openUpdConfirmationModal() {
      this.isShowUpdConfirmationModal = true;
    },

    openDelConfirmationModal() {
      this.isShowDelConfirmationModal = true;
    },

    cancelUpdConfirmationModal: function () {
      this.logger.debug(
        "更新確認モーダルからCancelクリックイベントが返されました"
      );
      this.isShowUpdConfirmationModal = false;
    },

    cancelDelConfirmationModal: function () {
      this.logger.debug(
        "削除確認モーダルからCancelクリックイベントが返されました"
      );
      this.isShowDelConfirmationModal = false;
    },

    okUpdConfirmationModal: function () {
      // ローディングアイコン表示
      this.isPostLoading = true;

      //DBへの書き込みAPIを呼び出す
      this.logger.debug("start to put a training planning");

      let api_url;
      api_url = API_BASE_URL + "training-plannings/" + this.plan_id;

      axios
        .put(
          api_url,
          {
            properties: {
              trainingId: this.training_id,
              trainingPlanningName: this.training_planning_name,
              date: this.date,
              startHour: this.start_hour,
              startMinute: this.start_minute,
              endHour: this.end_hour,
              endMinute: this.end_minute,
              place: this.place,
              training_material_url: this.trainingMaterialUrl,
              coaches: this.coaches,
              is_url_create_enabled: this.is_url_create_enabled,
              is_recording_enabled: this.is_recording_enabled,
              web_meeting_conn_setting_id: this.web_meeting_connection_selected,
              recording_share_ur: this.share_url,
              teams_host_user_id: this.teams_host_user_id
            }
          },
          {
            headers: {
              Authorization: this.$store.getters.currentUser.idToken.jwtToken
            }
          }
        )

        .then((result) => {
          this.logger.debug("put api result:\n" + JSON.stringify(result));
          this.isShowUpdConfirmationModal = false;

          if ("statusCode" in result.data) {
            //statusCodeが200なら予実一覧に遷移（今登録したものを確認できる）
            if (result.data.statusCode == 200) {
              this.logger.debug("end to put a training planning");
              this.isPostLoading = false;
              this.openSharingModal();
            } else if (result.data.statusCode == 500) {
              this.logger.error("API status 500 error");
              this.logger.error(JSON.stringify(result));
              this.$router.push("/system-error500");
            } else if (result.data.statusCode == 400) {
              this.error =
                "入力値に誤りがあります。再度入力してください。解決しない場合は、システム管理者経由でLECOチームにご連絡ください";
            } else {
              this.logger.error("PUT API unexpected status error");
              this.logger.error(JSON.stringify(result));
              this.$router.push("/system-error500");
            }
          } else {
            this.logger.error("PUT API Unexpected error");
            this.logger.error(JSON.stringify(result));
            this.$router.push("/system-error500");
          }
          this.isPostLoading = false;
        })
        .catch((err) => {
          this.logger.error("error in put training plan");
          this.logger.error(err);
          this.isPostLoading = false;
          this.$router.push("/system-error500");
        });
    },

    okDelConfirmationModal: function () {
      // ローディングアイコン表示
      this.isPostLoading = true;

      //トレーニング予定削除APIを呼び出す
      this.logger.debug("start to delete a training planning");
      let api_url2;
      api_url2 = API_BASE_URL + "training-plannings/" + this.plan_id;

      this.logger.debug("id:" + this.plan_id);

      axios
        .delete(api_url2, {
          headers: {
            Authorization: this.$store.getters.currentUser.idToken.jwtToken
          }
        })
        .then((result) => {
          this.logger.debug("del api result:\n" + JSON.stringify(result));
          this.isPostLoading = false;

          if ("statusCode" in result.data) {
            //statusCodeが200なら予実一覧に遷移（今登録したものを確認できる）
            if (result.data.statusCode == 200) {
              this.logger.debug(JSON.stringify(result));
              this.logger.debug("end to post a training planning");
              this.$router.push("/");
            } else {
              this.logger.error("DELETE API status Unexpected error");
              this.logger.error(JSON.stringify(result));
              this.$router.push("/system-error500");
            }
          } else {
            this.logger.error("DELETE API Unexpected error");
            this.logger.error(JSON.stringify(result));
            this.$router.push("/system-error500");
          }
        })
        .catch((err) => {
          this.isPostLoading = false;
          this.logger.error("error in delete training plan");
          this.logger.error(err);
          this.$router.push("/system-error500");
        });
    },

    okAnnounceModal: function () {
      this.logger.debug(
        "トレーニング内容共有モーダルからOKクリックイベントが返されました"
      );
      this.isShowSharingModal = false;
      this.$router.push("/");
    },

    openSharingModal() {
      this.isShowSharingModal = true;
    },

    closeModal() {
      this.isShowSharingModal = false;
    },

    checkPastDateTraining() {
      var today = new Date();

      // 年、月、日を取得
      var year = today.getFullYear();
      var month = ("0" + (today.getMonth() + 1)).slice(-2);
      var day = ("0" + today.getDate()).slice(-2);

      // yyyy-mm-dd形式に整形
      var formattedToday = year + "-" + month + "-" + day;
      this.logger.debug("today is " + formattedToday);
      this.logger.debug("training day is " + this.date);
      if (this.date < formattedToday) {
        this.logger.debug("checkPastDateTraining() return true.");
        return true;
      } else {
        this.logger.debug("checkPastDateTraining() return false.");
        return false;
      }
    }
  }, //methods

  created() {
    // 画面スクロールをトップにする
    this.instantScrollTop();

    this.mainLoading = true;
    this.plan_id = this.$route.params.id;

    //社員名一覧を取得
    let api_url = API_BASE_URL + "users";
    this.logger.debug("Start to get user list");
    axios
      .get(api_url, {
        headers: {
          Authorization: this.$store.getters.currentUser.idToken.jwtToken
        }
      })
      .then((result) => {
        if ("statusCode" in result.data) {
          if (result.data.statusCode == 200) {
            this.users = result.data.body;
            this.logger.debug("users:");
            this.logger.debug(JSON.stringify(this.users));
            this.logger.debug("End to get user list");
          } else {
            this.logger.error("GET(user list) API status Unexpected error");
            this.logger.error(JSON.stringify(result));
            this.$router.push("/system-error500");
          }
        } else {
          this.logger.error("GET(user list) API Unexpected error");
          this.logger.error(JSON.stringify(result));
          this.$router.push("/system-error500");
        }
        // 2つのAPIを非同期で呼び出しているので、
        // 両方完了までローディング中とする
        this.isUserGetted = true;
        this.mainLoading = !this.isUserGetted && this.isTrainingInfoGetted;
      })
      .catch((err) => {
        this.mainLoading = false;
        this.logger.error("error in getting user list");
        this.logger.error(JSON.stringify(err));
        this.$router.push("/system-error500");
      });

    //更新対象のトレーニング予定の情報を取得
    let api_url2 = API_BASE_URL + "training-plannings/" + this.plan_id;

    this.logger.debug("Start to get training plan");
    axios
      .get(api_url2, {
        headers: {
          Authorization: this.$store.getters.currentUser.idToken.jwtToken
        }
      })
      .then((result) => {
        this.logger.debug(JSON.stringify(result));
        if ("statusCode" in result.data) {
          if (result.data.statusCode == 200) {
            this.training_master_id = result.data.body.training_master_id;
            this.training_name = result.data.body.training_name;
            this.training_planning_name =
              result.data.body.training_planning_name;
            this.training_category_id = result.data.body.training_category_id;
            this.training_category_name =
              result.data.body.training_category_name;
            this.training_sub_category_id =
              result.data.body.training_sub_category_id;
            this.training_sub_category_name =
              result.data.body.training_sub_category_name;
            this.training_id = result.data.body.training_id;
            this.date = result.data.body.datetime_from.substr(0, 10);
            this.start_hour = result.data.body.datetime_from.substr(-8, 2);
            this.start_minute = result.data.body.datetime_from.substr(-5, 2);
            this.end_hour = result.data.body.datetime_to.substr(-8, 2);
            this.end_minute = result.data.body.datetime_to.substr(-5, 2);
            this.web_meeting_connection_selected =
              result.data.body.web_meeting_connection_setting_id;
            //講師情報を取得する
            this.coaches = result.data.body.coaches;
            this.share_url = result.data.body.share_url;
          
            //取得した講師情報リストにIndexと内部講師フラグを付与する。
            //また、ユーザーIDを数字から文字型に変換する（リストボックスで名前を正しく表示するため）
            for (var i = 0; i < this.coaches.length; i++) {
              this.coaches[i].coach_user_id = String(
                this.coaches[i].coach_user_id
              );
              this.coaches[i].index = i;
              //外部講師の場合、フラグを0にする
              if (this.coaches[i].coach_user_id == 0) {
                this.coaches[i].internal_coach_flag = 0;
              } else {
                //ケンブリッジ内部講師の場合、フラグを1にする
                this.coaches[i].internal_coach_flag = 1;
              }
            }

            this.logger.debug("coaches" + JSON.stringify(this.coaches));

            this.is_url_create_enabled = result.data.body
              .is_url_create_enabled
              ? true
              : false;
            // 0,1をtrue,falseに変換
            this.is_recording_enabled = result.data.body
              .is_recording_enabled
              ? true
              : false;
            this.meeting_id = result.data.body.meeting_id;
            this.join_url = result.data.body.join_url;
            this.place = result.data.body.place;
            this.trainingMaterialUrl = result.data.body.training_material_url;
            this.target_person = result.data.body.target_person;
            this.informationMsg = result.data.body.announce_text;

            //内部講師かつ講師名が入力済みの場合、講師名選択済みフラグを立てる
            if (
              this.coaches[0].coach_type == "0" &&
              this.coaches[0].coach_name.length > 0
            ) {
              this.isUserSelected = "1";
            }

            this.logger.info("isUserSelected:" + this.isUserSelected);
            this.logger.debug("end to get training plan");
            this.teams_host_user_id =String(result.data.body.teams_host_id);
            console.log("Teams Host User ID:", this.teams_host_user_id); 
            const user = this.users.find(
              (user) => user.id ===  String(this.teams_host_user_id)
            );
            console.log("Matched User:", user);
            
            
          } else {
            this.logger.error("API(training plan get) unexpected status error");
            this.logger.error(JSON.stringify(result));
            this.$router.push("/system-error500");
          }
        } else {
          this.logger.error("API(training plan get) unexpected error");
          this.logger.error(JSON.stringify(result));
          this.$router.push("/system-error500");
        }
        // 2つのAPIを非同期で呼び出しているので、
        // 両方完了までローディング中とする
        this.isTrainingInfoGetted = true;
        this.mainLoading = !this.isUserGetted && this.isTrainingInfoGetted;
      })
      .catch((err) => {
        this.mainLoading = false;
        this.logger.error("error in getting training plan");
        this.logger.error(err);
        this.$router.push("/system-error500");
      });

    //Teams接続設定一覧を取得
    let api_url3 = API_BASE_URL + "zoom/connection/settings/";
    this.logger.debug("Start to get web Meeting connection settings");
    axios
      .get(api_url3, {
        headers: {
          Authorization: this.$store.getters.currentUser.idToken.jwtToken
        }
      })
      .then((response) => {
        if ("statusCode" in response.data) {
          if (response.data.statusCode == 200) {
            this.logger.debug(JSON.stringify(response));
            for (let i = 0; i < response.data.body.web_meeting_settings.length; i++) {
              let setting = {
                text: response.data.body.web_meeting_settings[i].setting_name,
                value: response.data.body.web_meeting_settings[i].id
              };
              this.web_meeting_connection_settings.push(setting);
            }
          } else {
            this.logger.error("error not 200 get web meeting connection settings");
            this.logger.error(JSON.stringify(response));
            this.$router.push("/system-error500");
          }
        } else {
          this.logger.error("error not 200 get web meeting connection settings");
          this.logger.error(JSON.stringify(response));
          this.$router.push("/system-error500");
        }
      })
      .catch((err) => {
        this.logger.error(
          "error not found statusCode web meeting connection settings"
        );
        this.logger.error(JSON.stringify(err));
        this.$router.push("/system-error500");
      });
  }, //created
  computed: {
    ...mapGetters(["currentUser"])
  }
}; //export
</script>

<style scoped>
.user-select-list {
  width: 100%;
}

.post-loading {
  z-index: 20000;
}

.share-btn {
  margin-right: 25px;
}

.coach-add-btn {
  margin-left: 15px;
  margin-right: 15px;
}

.coach-delete-btn {
  margin-left: 15px;
}

.coach_wraper {
  padding-top: 20px;
  padding-bottom: 20px;
  border-radius: 5px;
  border: 1px solid #d4d9df;
  padding-left: 15px;
  padding-right: 15px;
}

.registry-btn {
  margin-left: 10px;
}

.tag-disp {
  border: solid 1px #6c757d;
  border-radius: 20px;
  padding: 3px 15px;
  background: #e9ecef;
  margin-left: 7px;
  margin-right: 30px;
  margin-bottom: 15px;
}

.vertical-middle-wrapper {
  display: flex;
  align-items: center;
}

@media screen and (max-width: 600px) {
  .registry-btn,
  .training-delete-btn {
    width: 100% !important;
    margin-top: 10px;
    margin-bottom: 10px;
    margin-left: 0px;
    margin-right: 0px;
  }
  .time-select {
    width: 60px;
  }
}
.registry-btn,
.training-delete-btn {
  width: 150px;
}

.radio-inline {
  padding-right: 1em;
}

.radio-left-margin {
  padding-left: 0.5em;
}

.select-group {
  width: fit-content;
}

.form-group {
  margin-bottom: 1.3rem;
}

.time-from-to-group {
  margin-bottom: 0;
}

.margin-side {
  margin-right: 10px;
  margin-left: 10px;
}

.alert {
  position: relative;
  padding: 0.3rem;
  margin-bottom: 1rem;
  border: 1px solid transparent;
  border-radius: 0.25rem;
}

/* loadingアイコン用CSS */
.loader {
  font-size: 10px;
  margin: 50px auto;
  text-indent: -9999em;
  width: 5em;
  height: 5em;
  border-radius: 50%;
  background: #000000;
  background: -moz-linear-gradient(
    left,
    #000000 10%,
    rgba(255, 255, 255, 0) 42%
  );
  background: -webkit-linear-gradient(
    left,
    #000000 10%,
    rgba(255, 255, 255, 0) 42%
  );
  background: -o-linear-gradient(left, #000000 10%, rgba(255, 255, 255, 0) 42%);
  background: -ms-linear-gradient(
    left,
    #000000 10%,
    rgba(255, 255, 255, 0) 42%
  );
  background: linear-gradient(
    to right,
    #000000 10%,
    rgba(255, 255, 255, 0) 42%
  );
  position: relative;
  -webkit-animation: load3 1.4s infinite linear;
  animation: load3 1.4s infinite linear;
  -webkit-transform: translateZ(0);
  -ms-transform: translateZ(0);
  transform: translateZ(0);
}
.loader:before {
  width: 50%;
  height: 50%;
  background: #000000;
  border-radius: 100% 0 0 0;
  position: absolute;
  top: 0;
  left: 0;
  content: "";
}
.loader:after {
  background: #ffffff;
  width: 75%;
  height: 75%;
  border-radius: 50%;
  content: "";
  margin: auto;
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
}

@-webkit-keyframes load3 {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
@keyframes load3 {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
</style>
